import React from 'react'
import UserIcon from "../../../../../../../gd-components/icons/user/user";

const debug = false
// const debug = "FieldTaskAssignedToUser_PickerValueNotEmpty"

export default function FieldTaskAssignedToUser_PickerValueNotEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    const iconSize      = _.get(props.configOptions, 'size', '22')

    const userId        = props.value
    const user          = gd.session.users.get(userId)!
    const iconClasses   = Classes({
        'm-r-5': !props.noLabel
    })

    return (
        <div className={Classes("flex-row-left-center", props.className)} onClick={props.onClick}>
            <UserIcon className={iconClasses} userId={user.id} size={iconSize}/>
            {!props.noLabel && <div className="ui5-txt-less-important-small">{user.name}</div>}
            {props.children}
        </div>
    )
}
